/*
 * author kcz
 * date 2019-11-20
 * description 表单控件项
 */
// 内置控件
export const defaultSchemaList = [
  {
    type: "input", // 表单类型
    sequence: "1", // 题目序号
    label: "文本", // 标题文字
    commponentTypeName: "文本", // 标题文字
    icon: "icon-write",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      type: "text",
      width: "100%", // 宽度
      defaultValue: "", // 默认值
      placeholder: "请输入文本", // 没有输入时，提示文字
      clearable: false,
      maxLength: null,
      addonBefore: "",
      addonAfter: "",
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      disabled: false, // 是否禁用，false不禁用，true禁用
      checkReg: null,
    },
    model: "", // 数据字段
    key: "",
    help: "",
    rules: [
      //验证规则
      {
        required: false, // 必须填写
        message: "必填项"
      }
    ]
  },
  {
    type: "textarea", // 表单类型
    sequence: "1", // 题目序号
    label: "多文本", // 标题文字
    commponentTypeName: "多文本", // 标题文字
    icon: "icon-edit",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      width: "100%", // 宽度
      minRows: 4,
      maxRows: 6,
      maxLength: null,
      defaultValue: "",
      unit: "",
      clearable: false,
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      disabled: false,
      placeholder: "请输入文本",
      checkReg: null,
    },
    model: "", // 数据字段
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "number", // 表单类型
    sequence: "1", // 题目序号
    label: "数字", // 标题文字
    commponentTypeName: "数字", // 标题文字
    icon: "icon-number",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      width: "100%", // 宽度
      defaultValue: null, // 默认值
      min: null, // 可输入最小值
      max: null, // 可输入最大值
      unit: null,
      precision: null,
      // step: 1, // 步长，点击加减按钮时候，加减多少
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      disabled: false, //是否禁用
      placeholder: "请输入数字",
      checkReg: null,
    },
    model: "", // 数据字段
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "knumber", // 表单类型
    sequence: "1", // 题目序号
    label: "数字", // 标题文字
    commponentTypeName: "数字", // 标题文字
    icon: "icon-number",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      width: "100%", // 宽度
      defaultValue: null, // 默认值
      min: null, // 可输入最小值
      max: null, // 可输入最大值
      unit: null,
      precision: null,
      // step: 1, // 步长，点击加减按钮时候，加减多少
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      disabled: false, //是否禁用
      placeholder: "请输入数字",
      checkReg: null,
    },
    model: "", // 数据字段
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "select", // 表单类型
    sequence: "1", // 题目序号
    label: "下拉选择器", // 标题文字
    commponentTypeName: "下拉选择器", // 标题文字
    icon: "icon-xiala",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      width: "100%", // 宽度
      defaultValue: undefined, // 下拉选框请使用undefined为默认值
      multiple: false, // 是否允许多选
      disabled: false, // 是否禁用
      clearable: false, // 是否显示清除按钮
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      placeholder: "请选择下拉选项", // 默认提示文字
      dynamicKey: "",
      dynamic: false,
      options: [
        // 下拉选择项配置
        {
          value: "1",
          label: "下拉框1"
        },
        {
          value: "2",
          label: "下拉框2"
        }
      ],
      showSearch: false // 是否显示搜索框，搜索选择的项的值，而不是文字
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "checkbox",
    sequence: "1", // 题目序号
    label: "多选",
    commponentTypeName: "多选",
    icon: "icon-duoxuan1",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      disabled: false, //是否禁用
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      defaultValue: [],
      dynamicKey: "",
      dynamic: false,
      options: [
        {
          value: "1",
          label: "选项1"
        },
        {
          value: "2",
          label: "选项2"
        },
        {
          value: "3",
          label: "选项3"
        }
      ]
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "radio", // 表单类型
    sequence: "1", // 题目序号
    label: "单选", // 标题文字
    commponentTypeName: "单选", // 标题文字
    icon: "icon-danxuan-cuxiantiao",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      disabled: false, //是否禁用
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      defaultValue: "", // 默认值
      dynamicKey: "",
      dynamic: false,
      options: [
        {
          value: "1",
          label: "选项1"
        },
        {
          value: "2",
          label: "选项2"
        },
        {
          value: "3",
          label: "选项3"
        }
      ]
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "datetime", // 表单类型
    sequence: "1", // 题目序号
    label: "时间", // 标题文字
    commponentTypeName: "时间", // 标题文字
    icon: "icon-calendar",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      width: "100%", // 宽度
      defaultValue: "", // 默认值，字符串 12:00:00
      rangeDefaultValue: [], // 默认值，字符串 12:00:00
      range: false, // 范围日期选择，为true则会显示两个时间选择框（同时defaultValue和placeholder要改成数组），
      showTime: {format: 'HH:mm'}, // 是否显示时间选择器
      disabled: false, // 是否禁用
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      clearable: false, // 是否显示清除按钮
      placeholder: "请选择时间",
      rangePlaceholder: ["开始时间", "结束时间"],
      format: "YYYY-MM-DD HH:mm" // 展示格式  （请按照这个规则写 YYYY-MM-DD HH:mm:ss，区分大小写）
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "date", // 表单类型
    sequence: "1", // 题目序号
    label: "日期", // 标题文字
    commponentTypeName: "日期", // 标题文字
    icon: "icon-calendar",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      width: "100%", // 宽度
      defaultValue: "", // 默认值，字符串 12:00:00
      rangeDefaultValue: [], // 默认值，字符串 12:00:00
      range: false, // 范围日期选择，为true则会显示两个时间选择框（同时defaultValue和placeholder要改成数组），
      showTime: false, // 是否显示时间选择器
      disabled: false, // 是否禁用
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      clearable: false, // 是否显示清除按钮
      placeholder: "请选择日期",
      rangePlaceholder: ["开始时间", "结束时间"],
      format: "YYYY-MM-DD" // 展示格式  （请按照这个规则写 YYYY-MM-DD HH:mm:ss，区分大小写）
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "time", // 表单类型
    sequence: "1", // 题目序号
    label: "时分", // 标题文字
    commponentTypeName: "时分", // 标题文字
    icon: "icon-time",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      width: "100%", // 宽度
      defaultValue: "", // 默认值，字符串 12:00:00
      disabled: false, // 是否禁用
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      clearable: false, // 是否显示清除按钮
      placeholder: "请选择时分",
      format: "HH:mm:ss" // 展示格式
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "rate", // 表单类型
    sequence: "1", // 题目序号
    label: "评分", // 标题文字
    commponentTypeName: "评分", // 标题文字
    icon: "icon-pingfen_moren",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      defaultValue: 0,
      max: 5, // 最大值
      disabled: false, // 是否禁用
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      allowHalf: false // 是否允许半选
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "slider", // 表单类型
    sequence: "1", // 题目序号
    label: "滑行数字", // 标题文字
    commponentTypeName: "滑行数字", // 标题文字
    icon: "icon-menu",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      width: "100%", // 宽度
      defaultValue: 0, // 默认值， 如果range为true的时候，则需要改成数组,如：[12,15]
      disabled: false, // 是否禁用
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      min: 0, // 最小值
      max: 100, // 最大值
      step: 1, // 步长，取值必须大于 0，并且可被 (max - min) 整除
      showInput: false // 是否显示输入框，range为true时，请勿开启
      // range: false // 双滑块模式
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "uploadFile", // 表单类型
    sequence: "1", // 题目序号
    label: "文件", // 标题文字
    commponentTypeName: "文件", // 标题文字
    icon: "icon-upload",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      defaultValue: "[]",
      multiple: false,
      disabled: false,
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      drag: false,
      downloadWay: "a",
      dynamicFun: "",
      width: "100%",
      limit: 3,
      data: "{}",
      fileName: "file",
      headers: {},
      action: "https://examples.epicjs.cn/epic-mock/common/upload",
      placeholder: "请上传文件"
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "uploadImg",
    sequence: "1", // 题目序号
    label: "上传图片",
    commponentTypeName: "上传图片",
    icon: "icon-image",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      defaultValue: "[]",
      multiple: false,
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      disabled: false,
      width: "100%",
      data: "{}",
      limit: 3,
      placeholder: "请上传图片",
      fileName: "image",
      headers: {},
      action: "https://examples.epicjs.cn/epic-mock/common/upload",
      listType: "picture-card"
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "treeSelect", // 表单类型
    sequence: "1", // 题目序号
    label: "树选择器", // 标题文字
    commponentTypeName: "树选择器", // 标题文字
    icon: "icon-tree",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      disabled: false, //是否禁用
      defaultValue: undefined, // 默认值
      multiple: false,
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      clearable: false, // 是否显示清除按钮
      showSearch: false, // 是否显示搜索框，搜索选择的项的值，而不是文字
      treeCheckable: false,
      placeholder: "请选择选项",
      dynamicKey: "",
      dynamic: false,
      options: [
        {
          value: "1",
          label: "选项1",
          children: [
            {
              value: "11",
              label: "选项11"
            }
          ]
        },
        {
          value: "2",
          label: "选项2",
          children: [
            {
              value: "22",
              label: "选项22"
            }
          ]
        }
      ]
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "cascader", // 表单类型
    sequence: "1", // 题目序号
    label: "级联选择器", // 标题文字
    commponentTypeName: "级联选择器", // 标题文字
    icon: "icon-guanlian",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      disabled: false, //是否禁用
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      defaultValue: undefined, // 默认值
      showSearch: false, // 是否显示搜索框，搜索选择的项的值，而不是文字
      placeholder: "请选择级联",
      clearable: false, // 是否显示清除按钮
      dynamicKey: "",
      dynamic: false,
      options: [
        {
          value: "1",
          label: "选项1",
          children: [
            {
              value: "11",
              label: "选项11"
            }
          ]
        },
        {
          value: "2",
          label: "选项2",
          children: [
            {
              value: "22",
              label: "选项22"
            }
          ]
        }
      ]
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "batch",
    sequence: "1", // 题目序号
    label: "动态表格",
    commponentTypeName: "动态表格",
    icon: "icon-biaoge",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    list: [],
    options: {
      scrollY: 0,
      minLimit: 1,
      disabled: false,
      hidden: false, // 是否隐藏，false显示，true隐藏
      showLabel: false,
      hideSequence: false,
      width: "100%"
    },
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ],
    model: "",
    key: "",
    help: ""
  },
  {
    type: "selectInputList",
    sequence: "1", // 题目序号
    label: "选择输入列",
    commponentTypeName: "选择输入列",
    icon: "icon-biaoge",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    columns: [
      {
        value: "1",
        label: "选项1",
        list: []
      },
      {
        value: "2",
        label: "选项2",
        list: []
      }
    ],
    options: {
      disabled: false,
      multiple: true, // 是否允许多选
      hidden: false, // 是否隐藏，false显示，true隐藏
      showLabel: false,
      width: "100%"
    },
    model: "",
    key: "",
    help: ""
  },
  {
    type: "editor",
    sequence: "1", // 题目序号
    label: "富文本",
    commponentTypeName: "富文本",
    icon: "icon-LC_icon_edit_line_1",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    list: [],
    options: {
      height: 300,
      placeholder: "请输入富文本",
      defaultValue: "",
      chinesization: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      disabled: false,
      showLabel: false,
      width: "100%"
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "switch", // 表单类型
    sequence: "1", // 题目序号
    label: "开关", // 标题文字
    commponentTypeName: "开关", // 标题文字
    icon: "icon-kaiguan3",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      defaultValue: false, // 默认值 Boolean 类型
      showLabel: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      disabled: false // 是否禁用
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "button", // 表单类型
    sequence: "1", // 题目序号
    label: "按钮", // 标题文字
    commponentTypeName: "按钮", // 标题文字
    icon: "icon-button-remove",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      type: "primary",
      handle: "submit",
      dynamicFun: "",
      showLabel: false,
      hidden: false, // 是否隐藏，false显示，true隐藏
      disabled: false // 是否禁用，false不禁用，true禁用
    },
    key: ""
  },
  {
    type: "alert",
    sequence: "1", // 题目序号
    label: "警告提示",
    commponentTypeName: "警告提示",
    icon: "icon-zu",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      type: "success",
      description: "",
      showIcon: false,
      banner: false,
      showLabel: false,
      hidden: false, // 是否隐藏，false显示，true隐藏
      closable: false
    },
    key: ""
  },
  {
    type: "text",
    sequence: "1", // 题目序号
    label: "文字",
    commponentTypeName: "文字",
    icon: "icon-zihao",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      textAlign: "left",
      hidden: false, // 是否隐藏，false显示，true隐藏
      showRequiredMark: false,
      noFormItem: true,
      color: "rgba(0, 0, 0, 0.9)",
      fontFamily: "",
      fontSize: "10.5pt"
    },
    key: ""
  },
  {
    type: "html",
    sequence: "1", // 题目序号
    label: "HTML",
    commponentTypeName: "HTML",
    icon: "icon-ai-code",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    options: {
      noFormItem: true,
      hidden: false, // 是否隐藏，false显示，true隐藏
      defaultValue: "<strong>HTML</strong>"
    },
    key: ""
  },
  {
    type: "divider",
    sequence: "1", // 题目序号
    label: "分割线",
    commponentTypeName: "分割线",
    icon: "icon-fengexian",
    options: {
      orientation: "left",
      noFormItem: true
    },
    key: "",
    model: ""
  },
  {
    type: "card",
    sequence: "1", // 题目序号
    label: "卡片布局",
    commponentTypeName: "卡片布局",
    icon: "icon-qiapian",
    list: [],
    options: {
      noFormItem: true
    },
    key: "",
    model: ""
  },
  {
    type: "emptyCard",
    label: "父子题",
    commponentTypeName: "父子题",
    icon: "icon-qiapian",
    parent: [],
    list: [],
    options: {
      noFormItem: true,
      readme: '上半部分是父题目，下半部分是子题目，父题目只能有一个，子题目可以有多个，均为必填'
    },
    key: "",
    model: ""
  },
  {
    type: "selectCard",
    sequence: "1", // 题目序号
    label: "卡片-(选择)",
    commponentTypeName: "卡片-(选择)",
    icon: "icon-qiapian",
    required: false,
    disabled: false,
    conceal: false,
    scale: false,
    draw: false,
    important: false,
    description: null,
    img: '',
    list: [],
    options: {
      noFormItem: true,
      width: "100%", // 宽度
      defaultValue: undefined, // 下拉选框请使用undefined为默认值
      multiple: false, // 是否允许多选
      disabled: false, // 是否禁用
      clearable: false, // 是否显示清除按钮
      showLabel: false,
      hidden: false, // 是否隐藏，false显示，true隐藏
      placeholder: "请选择选项", // 默认提示文字
      dynamicKey: "",
      dynamic: false,
      options: [
        // 下拉选择项配置
        {
          value: "1",
          label: "下拉框1"
        },
        {
          value: "2",
          label: "下拉框2"
        }
      ],
      showSearch: false // 是否显示搜索框，搜索选择的项的值，而不是文字
    },
    model: "",
    key: "",
    help: "",
    rules: [
      {
        required: false,
        message: "必填项"
      }
    ]
  },
  {
    type: "tabs",
    sequence: "1", // 题目序号
    label: "标签页布局",
    commponentTypeName: "标签页布局",
    icon: "icon-tabs",
    options: {
      tabBarGutter: null,
      type: "line",
      tabPosition: "top",
      size: "default",
      noFormItem: true,
      animated: true
    },
    columns: [
      {
        value: "1",
        label: "选项1",
        list: []
      },
      {
        value: "2",
        label: "选项2",
        list: []
      }
    ],
    key: "",
    model: ""
  },
  {
    type: "grid",
    sequence: "1", // 题目序号
    label: "栅格布局",
    commponentTypeName: "栅格布局",
    icon: "icon-zhage",
    columns: [
      {
        span: 12,
        list: []
      },
      {
        span: 12,
        list: []
      }
    ],
    options: {
      noFormItem: true,
      gutter: 0
    },
    key: "",
    model: ""
  },
  {
    type: "table",
    sequence: "1", // 题目序号
    label: "表格布局",
    commponentTypeName: "表格布局",
    icon: "icon-biaoge",
    trs: [
      {
        tds: [
          {
            colspan: 1,
            rowspan: 1,
            list: []
          },
          {
            colspan: 1,
            rowspan: 1,
            list: []
          }
        ]
      },
      {
        tds: [
          {
            colspan: 1,
            rowspan: 1,
            list: []
          },
          {
            colspan: 1,
            rowspan: 1,
            list: []
          }
        ]
      }
    ],
    options: {
      width: "100%",
      bordered: true,
      bright: false,
      small: true,
      noFormItem: true,
      customStyle: ""
    },
    key: "",
    model: ""
  }
];
